// A package_id arriving on the /book URL means the user already picked a
// package outside the booking flow (landing page or /pricing), so the package
// step has nothing left to ask them.
//
// It cannot be applied at project-creation time: Projects::UpdatePackage on the
// Rails side reads project.address.city to compute the city discount, and the
// address only exists after the location step. So the id is held here until the
// package step, then submitted through the normal update call.
//
// sessionStorage rather than the URL because the value has to survive the
// login/OTP round trip and the client-side history replacement.
const KEY = 'kadro.pendingPackageId';

export const capturePendingPackage = (search) => {
	try {
		const id = new URLSearchParams(search || '').get('package_id');
		if (id) {
			window.sessionStorage.setItem(KEY, id);
		}
	} catch (e) {
		// Storage can be unavailable (private mode, blocked cookies). Losing the
		// id just means the user sees the package step, which is a safe fallback.
	}
};

export const readPendingPackage = () => {
	try {
		return window.sessionStorage.getItem(KEY);
	} catch (e) {
		return null;
	}
};

export const clearPendingPackage = () => {
	try {
		window.sessionStorage.removeItem(KEY);
	} catch (e) {
		// noop
	}
};
